package com.taocent.simple.compose.component.blockrichtext

import androidx.compose.ui.text.AnnotatedString
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockKind

@ExperimentalBlockRichTextApi
data class TextBlock(
    override val id: String = generateBlockId(),
    val content: AnnotatedString = AnnotatedString("")
) : DocumentBlock {
    override val blockKind: BlockKind get() = BlockKind.TEXT
}
